<template>

</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { svgControlCreate, } from '@/utils/js/leafletUtils';
import store from '@/store';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const homeMap = computed(() => store.getters.getHomeMap),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      }
  
const tileMap = computed(()=> store.getters['homeTile/tileMap'] );
watch(tileMap, (newd, old)=>{
  if(newd.size > 0){
    sideBySideMapInit(newd);
  }
})

const sideBySideMapInit = (tileMap)=>{
  if(!sideBySideShowFlag)return
  const list = Array.from(tileMap.values());
  // console.log(list);
  let leftMap, rightMap;
  leftMap = list.at(-1);
  rightMap = list.at(-2) || list.at(-1);
  if(sideBySideControl){
    sideBySideControl.setLeftLayers(leftMap);
    sideBySideControl.setRightLayers(rightMap);
  }else{
    sideBySideControl = L.control.sideBySide(leftMap, rightMap).addTo(map);
  }
}

let sideBySideShowFlag = false;

let sideBySideControl,
    sideBySideControlInit = ()=>{
      if(tileMap.value.size == 0){
        message('请勾选侦察地图后再进行操作', 2);
        return false;
      };
      return true;
    },
    sideBySideControlClear = ()=>{
      sideBySideControl && map.removeControl(sideBySideControl);
      sideBySideControl = undefined;
    }
const controlClick = ()=>{
  if(sideBySideControl){
    sideBySideControlClear();
    sideBySideShowFlag = false;
  }else{
    const flag = sideBySideControlInit();
    sideBySideShowFlag = flag;
    if(flag){
      sideBySideMapInit(tileMap.value);
    }
  }
}

let control, controlClose = ()=>{
  control && map.removeControl(control);
}
const controlInit = ()=>{
  control = svgControlCreate({
    title: '侦察地图对比',
    svgName: 'side',
  }, 'click', controlClick).addTo(map)
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  controlInit();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
  controlClose();
  sideBySideControlClear();
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>